module.exports = __webpack_public_path__ + "img/edge-factor-logo.e2f152a7.jpg";